import * as firebase from 'firebase/app';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyBgQHS0GHOQ4KYZFyX0KS1xGdziSAAwYEI",
    authDomain: "youngmap-267103.firebaseapp.com",
    databaseURL: "https://youngmap-267103.firebaseio.com",
    projectId: "youngmap-267103",
    storageBucket: "youngmap-267103.appspot.com",
    messagingSenderId: "472898700337",
    appId: "1:472898700337:web:ed13d6fcc0906264e04110",
    measurementId: "G-JSGWEM5WZL"
  }
firebase.initializeApp(config);

export default firebase;